import React, { useEffect, useState } from 'react';
import type { SetStateAction, Dispatch } from 'react';
import $i18n from '@/i18n';
import { Input, Message, Loading, Form } from '@b-design/fusion';
import Uploader from '@/components/Uploader';
import EditableTable from './component/edit';
import './index.less';
import Requests from '@/services/request';
import styles from './index.module.less';
import { Field, Drawer } from '@alifd/next';
import CalculateComponent from '@/components/CalculateComponent';
import { getQueryStringArgs } from '@/utils/url-parse';
import DarkToolTip from '@/components/DarkToolTip';
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Switch } from 'antd';
import JsAPIAuthTable from './component/jsApiAuthTable';
import { enableJsApiAuth } from '@/services/jsapiAuth';
import { addJsapiToAuthList, removeJsapiToAuthList } from '@/services/jsapiAuth'
import Button, { FormSubmit } from '@/components/Button';

interface setUpChannel {
  drawerVisible: boolean;
  setDrawerVisible: Dispatch<SetStateAction<boolean>>;
  editValue?: null | any;
  setEditValue?: Dispatch<any>;
  setPaginationValue: Dispatch<Record<'currentPage' | 'pageSize', number>>;
  onRefresh: () => void
}

const SetUpChannel: React.FC<setUpChannel> = ({
  drawerVisible,
  setDrawerVisible,
  editValue = null,
  setEditValue = () => { },
  setPaginationValue,
  onRefresh
}) => {
  const field = Field.useField();

  const { spaceId } = getQueryStringArgs();

  // 内容区域高度
  const [contentHeight, setContentHeight] = useState<number>(200);

  const isEdit = !!editValue;

  // app os
  const [callerData, setCallerData] = useState<any>([]);

  const [loading, setLoading] = useState<boolean>(false);

  const [openJsApiAuth, setOpenFlag] = useState<boolean>(!!editValue?.jsapiEnable);
  const [createdChannelId, setCreatedChannelId] = useState<string>('')

  useEffect(() => {
    setOpenFlag(!!editValue?.jsapiEnable)
  }, [editValue])


  const clearCache = () => {
    sessionStorage.removeItem('addTempSet');
    sessionStorage.removeItem('removeTempSet');

  }

  const submitForm = async (value, error) => {
    if (error) {
      const channelSettingFormContainer = document.getElementById('channelSettingFormContainer');
      channelSettingFormContainer?.scrollTo({ top: 0, behavior: 'smooth' }); // 使用平滑滚动
      return;
    }
    const { name, description, icon } = value;
    const params = {
      description,
      icon: icon?.[0]?.relativePath,
      innerCode: isEdit ? editValue?.innerCode : createdChannelId,
      name,
      spaceId,
      jsapiEnable: openJsApiAuth ? 1 : 0,
    };
    // setLoading(true);
    const data = await Promise.all([
      isEdit
        ? Requests.post('/rest/intercnn/publishChannel/update', { ...params })
        : Requests.post('/rest/intercnn/publishChannel/create', {
          ...params,
          channelTargets: callerData?.map((caller) => ({
            identifier: caller?.identifier,
            type: caller?.type,
          })),
        }),
      isEdit &&
      callerData?.map((caller) =>
        Requests.post('/rest/intercnn/channel/target/create', {
          channelCode: editValue?.innerCode,
          spaceId,
          identifier: caller?.identifier,
          type: caller?.type,
        }),
      ),
    ]);
    if (data[0]) {
        const addJsapiList = JSON.parse(sessionStorage.getItem('addTempSet') || '[]')
        const removeJsapiList = JSON.parse(sessionStorage.getItem('removeTempSet') || '[]')
        const channelCode = isEdit ? editValue?.innerCode : createdChannelId
        if (openJsApiAuth) {
          if (addJsapiList?.length) {
            await addJsapiToAuthList({ jsapiList: addJsapiList, spaceId, channelCode })
          }
          if (removeJsapiList?.length) {
            await removeJsapiToAuthList({ jsapiList: removeJsapiList, spaceId, channelCode })
          }
          clearCache()
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.channelSetting.appList.message.success',
              dm: '操作成功',
            }),
          });
        }
      }
      setDrawerVisible(false);
      // callback();
      setPaginationValue({
        currentPage: 1,
        pageSize: 12,
      });
  };

  useEffect(() => {
    if (isEdit) {
      setLoading(true);
      Requests.get('/rest/intercnn/channel/target/query', {
        channelCode: editValue?.innerCode,
      }).then((data) => {
        if (data) {
          const { list = [] } = data;
          setCallerData(list);
        }
        setLoading(false);
      });
    }
  }, [isEdit, editValue]);

  const syncJsApiEnableToServer = (v) => {

    enableJsApiAuth({
      channelCode: editValue?.innerCode,
      spaceId
    }).then(res => {
      if (res) {
        setOpenFlag(state => v)
        setCreatedChannelId(res)
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.channelSetting.enableJsapiAuth.message.success',
            dm: '开启 JSAPI 授权功能成功',
          }),
        });
      } else {
        Message.error({
          title: $i18n.get({
            id: 'aopf.pages.channelSetting.enableJsapiAuth.message.failure',
            dm: '开启 JSAPI 授权功能失败',
          }),
        });
      }
    })
  }
  const onClose = () => {
    setDrawerVisible(false);
    setEditValue(null);
    setCallerData([]);
    clearCache();
    onRefresh?.()
  }

  return (
    <Drawer
      cache={false}
      v2
      title={
        editValue
          ? $i18n.get({
            id: 'aopf.pages.channel.channelList.ModifyApp',
            dm: '修改应用',
          })
          : $i18n.get({
            id: 'aopf.pages.channel.channelList.CreateApp',
            dm: '创建应用',
          })
      }
      placement="right"
      width={900}
      visible={drawerVisible}
      onClose={() => {
        onClose();
      }}
    >
      <Loading visible={loading}>
        <div className={styles.channelSettingFormContainer}>
          <Form
            className="appSetting-container"
            // labelAlign="top"
            field={field}
          >
            <div
              id="channelSettingFormContainer"
              style={{ height: contentHeight, overflowY: 'auto' }}
              className={styles.formContainer}
            >
              {isEdit && (
                <Form.Item
                  labelAlign="top"
                  name="innerCode"
                  label={$i18n.get({ id: 'aopf.pages.channel.setUpAppCode', dm: '应用ID' })}
                >
                  <div className="description-container">{editValue?.innerCode || '-'}</div>
                </Form.Item>
              )}
              <Form.Item
                labelAlign="top"
                name="name"
                label={$i18n.get({ id: 'aopf.pages.channel.setUpChannelName', dm: '应用名称' })}
                required
                requiredMessage={$i18n.get({
                  id: 'aopf.pages.channel.setUpChannelName.rules',
                  dm: '请输入应用名称',
                })}
              >
                <Input
                  placeholder={$i18n.get({
                    id: 'aopf.pages.channel.setUpChannelNamePlacehold',
                    dm: '请输入不超过30个字符的应用名称',
                  })}
                  style={{ width: '95%' }}
                  minLength={1}
                  maxLength={30}
                  defaultValue={editValue?.name}
                />
              </Form.Item>
              <Form.Item
                labelAlign="top"
                labelTextAlign="left"
                name="icon"
                label={$i18n.get({ id: 'aopf.pages.channel.setUpChannelIcon', dm: '图标' })}
                required
                requiredMessage={$i18n.get({
                  id: 'aopf.pages.channel.setUpChannelIcon.rules',
                  dm: '请上传图标!',
                })}
                className={styles.iconContainer}
              >
                <Uploader.Image
                  action="/rest/intercnn/publishChannel/uploadIcon"
                  accept={['image/png', 'image/jpg', 'image/jpeg']}
                  maxSize={120 * 1024}
                  key={editValue?.iconPublicUrl}
                  data={{ spaceId }}
                  settlein={true}
                  defaultValue={
                    editValue?.iconPublicUrl
                      ? [
                        {
                          uid: '0',
                          state: 'done',
                          publicUrl: editValue?.iconPublicUrl,
                          relativePath: editValue?.icon,
                        },
                      ]
                      : []
                  }
                  onError={() => {
                    Message.error({
                      title: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                        dm: '上传失败',
                      }),
                    });
                  }}
                  onCheckFail={(_err, response) => {
                    Message.warning({ title: response.msg });
                  }}
                />
                <div className="upload-format" style={{ width: 'calc(95% - 100px - 10px)' }}>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format1',
                    dm: '文件类型:',
                  })}
                  <span>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.upload.img.format1.content',
                      dm: '.png / .jpg / .jpeg',
                    })}
                  </span>
                  <br />
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format2',
                    dm: '规格:',
                  })}
                  <span>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.upload.img.format2.content',
                      dm: '180px * 180px',
                    })}
                  </span>
                  <br />
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format3',
                    dm: '最大大小:',
                  })}
                  <span>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.upload.img.format3-1.content',
                      dm: '120KB',
                    })}
                  </span>
                  <br />
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format4',
                    dm: '背景:',
                  })}
                  <span>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.upload.img.format4.content',
                      dm: '不透明',
                    })}
                  </span>
                </div>
              </Form.Item>
              <Form.Item
                labelAlign="top"
                name="description"
                label={$i18n.get({ id: 'aopf.pages.channel.setUpChannelDesc', dm: '描述' })}
                minLength={2}
                maxLength={400}
                minmaxLengthMessage={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Description.placeholder',
                  dm: '输入2-400个字符的描述',
                })}
                required
                requiredMessage={$i18n.get({
                  id: 'aopf.pages.channel.setUpChannelDesc.rules',
                  dm: '请输入应用描述!',
                })}
              >
                <Input.TextArea
                  className={styles.descriptionText}
                  placeholder={$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.Description.placeholder',
                    dm: '输入2-400个字符的描述',
                  })}
                  showLimitHint
                  autoHeight={{ minRows: 4, maxRows: 8 }}
                  style={{ width: '95%' }}
                  maxLength={400}
                  defaultValue={editValue?.description}
                />
              </Form.Item>
              <Form.Item
                labelAlign="top"
                name="caller"
                label={$i18n.get({ id: 'aopf.pages.channel.setUpChannelCaller', dm: '应用调用方' })}
                validator={() => {
                  // const callerName = callerData?.map(i => i.identifier)
                  // if ((callerName?.length && callerName?.every(i => !!i)) || !callerName?.length) {
                  //   return Promise.resolve()
                  // }
                  // return Promise.reject(new Error($i18n.get({ id: 'aopf.pages.channel.setUpChannelCallerColumnsCallerPlacehold', dm: '请输入调用方!' })));

                  const callerName = callerData?.map((i) => i.identifier);
                  const callerType = callerData?.map((i) => i.type);
                  if (callerName?.length && callerName?.some((i) => !i)) {
                    return Promise.reject(
                      new Error(
                        $i18n.get({
                          id: 'aopf.pages.channel.setUpChannelCallerColumnsCallerPlacehold',
                          dm: '请输入调用方!',
                        }),
                      ),
                    );
                  }
                  if (callerName?.length && callerType?.some((i) => !i)) {
                    return Promise.reject(
                      new Error(
                        $i18n.get({
                          id: 'aopf.pages.channel.setUpChannelTypeColumnsCallerPlacehold',
                          dm: '请选择类别!',
                        }),
                      ),
                    );
                  }
                  return Promise.resolve();
                }}
              >
                <EditableTable
                  callerData={callerData}
                  setCallerData={setCallerData}
                  channelCode={editValue?.innerCode}
                />
              </Form.Item>


              {
                <div className={styles.jsApiAuthorizationContainer}>
                  <div className={styles.jsApiAuthTitle}>{
                    $i18n.get({
                      id: 'aopf.pages.channel.jsApiAuth.title',
                      dm: 'JSAPI 授权',
                    })
                  }</div>
                  <div className={styles.jsApiAuthTextBase} style={{ color: "#1A1A1A", marginBottom: 8 }}>
                    {$i18n.get({
                      id: 'aopf.pages.channel.jsApiAuth.desc1',
                      dm: '为保障应用的安全性和功能的可控性，对于非 Uni-app 类型的应用：',
                    })}
                  </div>
                  <div className={styles.jsApiAuthTextBase} style={{ color: "#585F7E", marginBottom: 16 }}>
                    {$i18n.get({
                      id: 'aopf.pages.channel.jsApiAuth.desc2',
                      dm: '当您希望限制特定 JSAPI 的使用时，请务必先将这些接口添加到授权列表中。只有经过此步骤的 JSAPI，在调用时才需要进行授权验证。而未被列入授权列表的 JSAPI，则默认允许小程序直接调用，无需额外授权。',
                    })}
                  </div>
                  <div className={styles.jsApiAuthTextBase} style={{ color: "#1A1A1A", marginBottom: 8, display: 'flex', flexFlow: 'row' }}>
                    {$i18n.get({
                      id: 'aopf.pages.channel.jsApiAuth.enableFeature',
                      dm: '是否开启 JSAPI 授权功能',
                    })}

                    <DarkToolTip placement="right" padding="8px 16px" triggerContent={<QuestionCircleOutlined style={{ marginLeft: 4, color: "#B4BACC" }} />} content={$i18n.get({
                      id: 'aopf.pages.channel.jsApiAuth.enableFeatureTip',
                      dm: '默认设置为关闭',
                    })} />
                  </div>
                  <Switch className={`${openJsApiAuth ? styles.jsApiOpenFlagChecked : ''}`} disabled={openJsApiAuth} size={'small'} checked={openJsApiAuth} onChange={(v) => syncJsApiEnableToServer(v)} />
                  <JsAPIAuthTable isEdit={isEdit} createChannelId={createdChannelId} openFlag={openJsApiAuth} callerData={callerData} spaceId={spaceId || ''} channelCode={editValue?.innerCode} />
                </div>
              }

            </div>

            <Form.Item label="" style={{ marginBottom: 0 }} labelAlign="top" labelTextAlign="left">
              <div className={styles.btnContainer}>
                <FormSubmit
                  type="primary"
                  onClick={submitForm}
                  validate
                  className={styles.submitBtn}
                >
                  {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Ok', dm: '确定' })}
                </FormSubmit>
                <Button
                  type="secondary"
                  onClick={() => {

                    onClose()
                  }}
                  className={styles.cancelBtn}
                >
                  {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Cancel', dm: '取消' })}
                </Button>
              </div>
            </Form.Item>
          </Form>



          <CalculateComponent
            otherWidth={280}
            otherHeight={48 + 36}
            windowChange={(_width, height) => {
              setContentHeight(height);
            }}
          />

        </div>
      </Loading>
    </Drawer>
  );
};
export default SetUpChannel;
